import { useLayoutEffect } from 'react';

import { pushThemeScope, type Theme } from '../lib/theme';

/**
 * Pins the root theme for as long as it is mounted, regardless of the operator's
 * preference (docs/15 §5) — used for the login hero, whose artwork is drawn
 * against navy. On unmount the root falls back to the preference **as it stands
 * then**, so a flip made in another tab while this was mounted is honoured.
 *
 * The pin is registered with `lib/theme.ts` rather than written to the DOM here:
 * that module is the single writer of `data-theme`, so a preference change
 * arriving mid-scope updates the preference without repainting the pinned
 * surface. Routes never nest two scopes, though nesting resolves innermost-first
 * if one ever appears.
 *
 * Prefer the preference for anything the operator works in for a whole shift;
 * reach for a scope only where a surface is a fixed piece of brand art.
 */
export function ThemeScope({ theme }: { theme: Theme }) {
  useLayoutEffect(() => pushThemeScope(theme), [theme]);
  return null;
}
